var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0806 13.9C10.341 13.9 8.1129 11.6798 8.1129 8.95C8.1129 6.22019 10.341 4 13.0806 4C15.8202 4 18.0484 6.22019 18.0484 8.95C18.0484 11.6798 15.8202 13.9 13.0806 13.9ZM13.0806 4.9C10.8395 4.9 9.01613 6.71688 9.01613 8.95C9.01613 11.1831 10.8395 13 13.0806 13C15.3218 13 17.1452 11.1831 17.1452 8.95C17.1452 6.71688 15.3218 4.9 13.0806 4.9ZM20.3065 21.9998H5.85484C5.10798 21.9998 4.5 21.394 4.5 20.6498C4.5 20.5885 4.51242 19.1333 5.60645 17.6798C6.24323 16.8338 7.11484 16.1616 8.19758 15.6829C9.51968 15.0968 11.163 14.7998 13.0806 14.7998C14.9983 14.7998 16.641 15.0968 17.9637 15.6829C19.0465 16.1627 19.9181 16.8338 20.5548 17.6798C21.6489 19.1333 21.6613 20.5885 21.6613 20.6498C21.6613 21.394 21.0533 21.9998 20.3065 21.9998ZM13.0806 15.7002C9.93121 15.7002 7.6071 16.558 6.35952 18.1808C5.42468 19.3969 5.40379 20.6395 5.40323 20.6524C5.40323 20.8988 5.60533 21.1008 5.85484 21.1008H20.3065C20.556 21.1008 20.7581 20.8994 20.7581 20.6508C20.7581 20.6401 20.7372 19.3969 19.8018 18.1814C18.5536 16.5586 16.2295 15.7008 13.0806 15.7008V15.7002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutline);
export default __webpack_public_path__ + "static/media/user-outline.d9c39ee3b81a2dcd9d4c44daa51d42bd.svg";
export { ForwardRef as ReactComponent };